/* CreditCardComparison - shared pure helpers */

export const parseFee = (val) => {
  if (!val || val === 'N/A') return 0;
  const s = String(val).trim().toLowerCase();
  if (s.includes('no annual fee')) return 0;
  const m = s.match(/([\d.]+)/);
  return m ? parseFloat(m[1]) : 0;
};

export const parseRate = (val) => {
  if (!val || val === 'N/A' || String(val).toLowerCase().includes('not available')) return null;
  const m = String(val).match(/([\d.]+)/);
  return m ? parseFloat(m[1]) : null;
};

export const getRewardType = (card) => {
  const r = (card.rewards || '').toLowerCase();
  if (r.includes('not available') || !r || r === 'n/d' || r === 'no rewards') return 'none';
  if (r.includes('cash') || r.includes('reembolso') || r.includes('money back')) return 'cashback';
  if (r.includes('miles') || r.includes('aeroplan') || r.includes('avion')) return 'miles';
  if (r.includes('points') || r.includes('puntos') || r.includes('scene') || r.includes('bonus')) return 'points';
  return 'other';
};

const NO_FEE = { es: 'Sin cuota', en: 'No fee', fr: 'Sans frais' };
export const fmtCurrency = (val, lang = 'es') => {
  const n = typeof val === 'number' ? val : parseFee(val);
  return n === 0 ? (NO_FEE[lang] || NO_FEE.es) : `$${n.toFixed(0)} CAD`;
};

export const fmtPercent = (val) => {
  const n = parseRate(val);
  return n !== null ? `${n.toFixed(2)}%` : 'N/D';
};

/**
 * Estimated first-year real cost: annual_fee + (average balance * purchase_rate).
 * Assumes $1,500 average balance for estimation purposes.
 */
export const getCostoRealAnual = (card) => {
  const fee = parseFee(card.annual_fee);
  const rate = parseRate(card.purchase_rate);
  const estimatedInterest = rate !== null ? (1500 * rate) / 100 : 0;
  return Math.round(fee + estimatedInterest);
};

export const parseIncome = (val) => {
  if (!val || val === 'N/A' || val.toLowerCase().includes('not required')) return 0;
  const m = String(val).match(/([\d,]+)/);
  return m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
};
